const Separator = ({
	vertical = false,
	section = "",
	hideInMobile,
	hideInDesktop,
}) => {
	const mainClass = "syndicated-separator";
	let classes = `${mainClass}--${vertical ? "vertical" : "horizontal"}`;
	classes += `${section ? ` ${mainClass}--${section}` : ""}`;
	if (hideInMobile) classes += ` ${mainClass}--hide-in-mobile`;
	if (hideInDesktop) classes += ` ${mainClass}--hide-in-desktop`;

	return <div className={classes}></div>;
};

export default Separator;
